import * as React from 'react';
import * as TypeStyle from 'typestyle';
import { ButtonProps, ButtonType } from './ButtonWidget';
import { MenuButtonProps } from './MenuButtonWidget';

import { ButtonAttrs } from '../../utils/HtmlAttrs';

export interface SplitButtonProps {
  /** The primary button. `buttonType` on this button will be overridden to Primary. */
  button: React.ReactElement<ButtonProps & ButtonAttrs>;

  /** This component does not use `children`. */
  children?: never;

  /** The popup button. `aria-label` or `aria-labelledby` must be set on its props, otherwise an error will be thrown. */
  menuButton: React.ReactElement<MenuButtonProps & ButtonAttrs>;
}

const ButtonStyleName = TypeStyle.style({
  borderTopRightRadius: 0,
  borderBottomRightRadius: 0,
  marginRight: `0 !important`,
});

const MenuButtonStyleName = TypeStyle.style({
  borderBottomLeftRadius: 0,
  borderTopLeftRadius: 0,
  marginLeft: `1px !important`,
  minWidth: `24px !important`,
  $nest: {
    '&:empty::after': {
      marginLeft: -6,
      marginRight: -6,
    }
  }
});

export const SplitButtonWidget: React.FC<SplitButtonProps> = props => {
  if (!(props.menuButton.props['aria-label'] || props.menuButton.props['aria-labelledby'])) {
    throw new Error('aria-label or aria-labelledby must be set on `menuButton` props.');
  }

  return <div style={{ display: 'inline-flex', whiteSpace: 'nowrap' }}>
    {React.cloneElement(props.button, {
      buttonType: ButtonType.Primary,
      className: TypeStyle.classes(props.button.props.className, ButtonStyleName),
      density: props.button.props.density || 'medium',
    })}
    {React.cloneElement(props.menuButton, {
      kind: 'primary',
      className: TypeStyle.classes(props.menuButton.props.className, MenuButtonStyleName),
      density: 'high',
    })}
  </div>;
};
SplitButtonWidget.displayName = 'SplitButtonWidget';
